export const SITE_ORIGIN = 'https://qgoldresources.com';
export const SITE_NAME = 'Q-Gold Resources';
export const DEFAULT_DESCRIPTION =
  'Q-Gold Resources is a Canadian gold company advancing the Quartz Mountain project in Oregon and Mine Centre in Ontario. News, technical reports, and investor materials.';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/qgold-logo.png`;

export const CANONICAL_ROUTES = new Set([
  '/',
  '/news',
  '/company',
  '/investors',
  '/contact',
  '/media-centre',
  '/legal-notice',
  '/coming-soon',
  '/project/mine-centre',
  '/project/quartz-mountain',
]);

export function absoluteUrl(path = '/') {
  if (!path || path === '/') return `${SITE_ORIGIN}/`;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized}`;
}
